import { createContext } from 'react'
import type { NavCrumb, NavOpts } from '../routes'

export interface NavigationState {
  ledgerReviewCaseIndex: number
  /** データ取込履歴から OCR 確認へ渡す取込バッチ ID（API の数値 id） */
  ledgerReviewImportBatchId: number | null
  /** データ取込履歴から OCR 確認へ渡す OCR 案件 ID（DB の ocr_import_cases.id） */
  ledgerReviewOcrCaseId: number | null
  recipientBaseCrumb: NavCrumb
  pendingAlert: string | null
  applicationReviewParentCrumb: NavCrumb
  applicationReviewPageTitle: string
  recipientDetailPageTitle: string
  appDocEditReturnPage: string
  notification: string | null
}

export interface NavigationContextValue extends NavigationState {
  /** Navigate using legacy page key + optional opts (same API as old onNavigate) */
  navigate: (target: string, opts?: NavOpts) => void
  showNotification: (msg: string) => void
  setPendingAlert: (alert: string | null) => void
  /** Current page key derived from URL */
  currentPage: string
}

export const NavigationContext = createContext<NavigationContextValue | null>(null)
